/**
 * Created by griga on 11/19/16.
 */

import React from 'react'
import * as ReactDOM from "react-dom";
import {BarLoader, BeatLoader, RingLoader} from "react-spinners";
import $ from 'jquery';
export default function(url) {
    let myToken = localStorage.getItem('access_token');
    const element = <div className="load-holder"><BarLoader color={'#ffc107'} width={200} /></div>;
    let  loadContainer = document.getElementById('load-container');
    if(loadContainer !== null) ReactDOM.render(element,loadContainer);

    return new Promise((resolve, reject)=>{
        $.ajax({
            type: "GET",
            url: url,
            dataType: 'json',
            // dataType: 'application/xml',
            beforeSend: setHeader
        }).done(function (data) {
            // if(loadContainer !== null) ReactDOM.unmountComponentAtNode( document.getElementById('load-container'));
            resolve(data)
        })
            .fail(reject)
            .always(function (){
            // if(loadContainer !== null) ReactDOM.unmountComponentAtNode( document.getElementById('load-container'));
        });
    });
    function setHeader(xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer '+myToken);
    }
}
